import React, { useState } from "react";
import { Box, Typography, TextField, Button, Alert, Grid } from "@mui/material";
import Layout from "./Layout";
import axios from "axios";
import { useNavigate, Link } from "react-router-dom";

const ChangePassword = () => {
  const [formData, setFormData] = useState({
    user_id: "",
    old_password: "",
    new_password: "",
    confirm_password: "",
  });

  const [formErrors, setFormErrors] = useState({});
  const [submissionError, setSubmissionError] = useState("");
  const navigate = useNavigate();
  const baseURL = process.env.REACT_APP_API_URL || "http://localhost:8000";

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const validate = () => {
    const errors = {};

    if (!formData.user_id) {
      errors.user_id = "Username is required";
    }

    if (!formData.old_password) {
      errors.old_password = "Old password is required";
    }

    if (!formData.new_password) {
      errors.new_password = "New password is required";
    } else {
      if (formData.new_password.length < 12) {
        errors.new_password = "Password must be at least 12 characters";
      } else if (formData.new_password.length > 24) {
        errors.new_password = "Password must be less than 24 characters";
      } else if (!/(?=.*[a-z])/.test(formData.new_password)) {
        errors.new_password =
          "Password must contain at least one lowercase letter";
      } else if (!/(?=.*[A-Z])/.test(formData.new_password)) {
        errors.new_password =
          "Password must contain at least one uppercase letter";
      } else if (!/(?=.*\d)/.test(formData.new_password)) {
        errors.new_password = "Password must contain at least one digit";
      } else if (
        !/(?=.*[[\]!@#$%^&*()_\-+=\]{};':"\\|,.<>/?])/.test(
          formData.new_password,
        )
      ) {
        errors.new_password =
          "Password must contain at least one special character";
      }
    }

    if (!formData.confirm_password) {
      errors.confirm_password = "Please confirm your new password";
    } else if (formData.confirm_password !== formData.new_password) {
      errors.confirm_password = "Passwords do not match";
    }

    return errors;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setSubmissionError("");
    const errors = validate();

    if (Object.keys(errors).length > 0) {
      setFormErrors(errors);
      return;
    }

    try {
      const response = await axios.post(
        `${baseURL}/licensing/change_password/`,
        {
          user_id: formData.user_id,
          old_password: formData.old_password,
          new_password: formData.new_password,
        },
      );

      if (response.data.status === "Pass") {
        navigate("/login");
      } else {
        setSubmissionError(response.data.status);
      }
    } catch (error) {
      console.error(error);
      setSubmissionError(
        error.response?.data?.message || "An unexpected error occurred.",
      );
    }
  };

  return (
    <Layout>
      <Typography variant="h5" gutterBottom>
        Change Password
      </Typography>

      <Box component="form" onSubmit={handleSubmit} sx={{ mt: 2 }}>
        {submissionError && (
          <Alert severity="error" sx={{ mb: 2 }}>
            {submissionError}
          </Alert>
        )}

        <TextField
          name="user_id"
          label="Username"
          fullWidth
          margin="normal"
          value={formData.user_id}
          onChange={handleChange}
          error={!!formErrors.user_id}
          helperText={formErrors.user_id}
        />

        <TextField
          name="old_password"
          label="Old Password"
          type="password"
          fullWidth
          margin="normal"
          value={formData.old_password}
          onChange={handleChange}
          error={!!formErrors.old_password}
          helperText={formErrors.old_password}
        />

        <TextField
          name="new_password"
          label="New Password"
          type="password"
          fullWidth
          margin="normal"
          value={formData.new_password}
          onChange={handleChange}
          error={!!formErrors.new_password}
          helperText={formErrors.new_password}
        />

        <TextField
          name="confirm_password"
          label="Reconfirm Password"
          type="password"
          fullWidth
          margin="normal"
          value={formData.confirm_password}
          onChange={handleChange}
          error={!!formErrors.confirm_password}
          helperText={formErrors.confirm_password}
        />

        <Button fullWidth variant="contained" type="submit" sx={{ mt: 2 }}>
          Change Password
        </Button>

        <Box mt={2}>
          <Grid container spacing={1}>
            <Grid item xs={12}>
              <Link to="/register">New here? Sign Up</Link>
            </Grid>
            <Grid item xs={12}>
              <Link to="/forgot">Forgot Credentials</Link>
            </Grid>
            <Grid item xs={12}>
              <Link to="/login">Already have an account? Log In</Link>
            </Grid>
          </Grid>
        </Box>
      </Box>
    </Layout>
  );
};

export default ChangePassword;
